export default __webpack_public_path__ + "static/media/PhysioThereapyBackgroung.38729dd9.svg";